module.exports = __webpack_public_path__ + "img/water_device.d51dd0d1.svg";